.cells {
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  width: 100%;
  table-layout: fixed;
  display: table;

  .thead {
    display: table-header-group;
    position: sticky;
    top: 0;
    background: white;
  }

  .tbody {
    display: table-row-group;
  }

  .th {
    scroll-snap-type: x mandatory;
    scroll-snap-align: center;
  }

  .tr {
    display: table-row;
    scroll-snap-type: y mandatory;
    scroll-snap-align: center;
  }

  .th,
  .td {
    display: table-cell;
  }

  .colgroup {
    display: table-column-group;
  }

  .col {
    display: table-column;
  }

  .rowNumbers {
    padding: 0;
    position: sticky;
    left: 0;
    background: white;
    @apply border-border;
    @apply border-t;
    @apply border-r;
    text-align: center;
  }

  tr:first-child .rowNumbers {
    border-top: none;
  }

  thead th {
    position: sticky;
    top: 0;
    background: white;
    z-index: 999;
  }

  thead tr,
  .thead .tr {
    height: 22px;
  }

  tbody tr,
  .tbody .tr {
    height: 20px;
  }

  th,
  .th {
    font-weight: normal;
    font-size: 10px;
  }

  thead tr:first-child th,
  .thead .th {
    padding: 2px 2px 1px;
    @apply border-border;
    @apply border-t;
    @apply border-b;
    @apply border-r;
    text-align: center;

    span {
      display: inline-block;
      min-width: 80px;
    }
  }

  tbody td,
  .tbody .td {
    height: 18px;
  }

  th,
  td,
  .th,
  .td {
    padding: 2px 0 0 3px;
    overflow: clip;
    white-space: nowrap;
    box-sizing: border-box;
  }
}

.showGrid {
  th,
  td,
  .td {
    @apply border-border;
    @apply border-t;
    @apply border-r;
  }

  .tr:first-child .td {
    border-top: none;
  }
}
